"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ArrayFields = void 0;
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.date.to-string.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _components = require("./components");
var _reduxForm = require("redux-form");
var _react = _interopRequireWildcard(require("react"));
var _validations = require("./validations");
var _propTypes = require("prop-types");
var _renderRow = _interopRequireDefault(require("./components/renderRow"));
var _lodash = _interopRequireDefault(require("lodash"));
var _fieldsLegacyOld = require("./fieldsLegacyOld");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["components", "interface", "inputs", "label", "smallLabel", "description", "options", "question_description", "title", "labelStyle", "inputStyle", "config", "validations", "fieldSpacing", "normalize", "format", "parse", "collapseable", "nowDate", "labelTooltip"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var RowContainer = _styledComponents["default"].div.withConfig({
  displayName: "fieldsArrayOld__RowContainer"
})(["display:flex;align-items:center;width:100%;& .row-field{width:100%;padding-left:8px;padding-right:8px;select{width:100%;}}"]);
var FieldsArray = /*#__PURE__*/function (_PureComponent) {
  function FieldsArray() {
    (0, _classCallCheck2["default"])(this, FieldsArray);
    return _callSuper(this, FieldsArray, arguments);
  }
  (0, _inherits2["default"])(FieldsArray, _PureComponent);
  return (0, _createClass2["default"])(FieldsArray, [{
    key: "render",
    value: function render() {
      var _inputs$,
        _this = this,
        _inputs$2;
      var _this$props = this.props,
        components = _this$props.components,
        intf = _this$props["interface"],
        _this$props$inputs = _this$props.inputs,
        inputs = _this$props$inputs === void 0 ? [] : _this$props$inputs,
        label = _this$props.label,
        smallLabel = _this$props.smallLabel,
        description = _this$props.description,
        options = _this$props.options,
        question_description = _this$props.question_description,
        title = _this$props.title,
        labelStyle = _this$props.labelStyle,
        inputStyle = _this$props.inputStyle,
        _this$props$config = _this$props.config,
        config = _this$props$config === void 0 ? {} : _this$props$config,
        validations = _this$props.validations,
        fieldSpacing = _this$props.fieldSpacing,
        normalize = _this$props.normalize,
        format = _this$props.format,
        parse = _this$props.parse,
        collapseable = _this$props.collapseable,
        nowDate = _this$props.nowDate,
        labelTooltip = _this$props.labelTooltip,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      config.disabled = this.props.disabled;
      var _generateCommonPassed = (0, _fieldsLegacyOld.generateCommonPassedProps)(this.props),
        listOfValidations = _generateCommonPassed.listOfValidations,
        wrapperContent = _generateCommonPassed.wrapperContent,
        fieldName = _generateCommonPassed.fieldName;
      listOfValidations = props.required ? [].concat((0, _toConsumableArray2["default"])(listOfValidations), [_validations.noEmptyArray]) : listOfValidations;
      switch (intf) {
        case "array":
          return /*#__PURE__*/_react["default"].createElement(_components.FieldWrapper, (0, _extends2["default"])({}, wrapperContent, {
            labelTooltip: labelTooltip
          }), /*#__PURE__*/_react["default"].createElement(_reduxForm.FieldArray, (0, _extends2["default"])({}, props, {
            components: components,
            validate: listOfValidations,
            name: fieldName,
            component: _components.RenderArray,
            nowDate: nowDate,
            config: props
          })));
        case "flatarray":
          return /*#__PURE__*/_react["default"].createElement(_components.FieldWrapper, (0, _extends2["default"])({}, wrapperContent, {
            labelTooltip: labelTooltip
          }), /*#__PURE__*/_react["default"].createElement(_reduxForm.FieldArray, (0, _extends2["default"])({}, this.props, {
            components: components,
            validate: listOfValidations,
            name: fieldName,
            inputStyle: inputStyle,
            labelStyle: labelStyle,
            label: label,
            component: _components.RenderFlatArray,
            nowDate: nowDate,
            config: props
          })));
        case 'row':
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("strong", null, label), /*#__PURE__*/_react["default"].createElement(RowContainer, null, inputs === null || inputs === void 0 ? void 0 : (_inputs$ = inputs[0]) === null || _inputs$ === void 0 ? void 0 : _inputs$.map(function (input, id) {
            return /*#__PURE__*/_react["default"].createElement(_renderRow["default"], (0, _extends2["default"])({
              key: "curious_panda_row_field_".concat(id)
            }, _this.props, {
              input: input
            }));
          })));
        case 'collapsable':
          return /*#__PURE__*/_react["default"].createElement("details", null, /*#__PURE__*/_react["default"].createElement("summary", null, /*#__PURE__*/_react["default"].createElement("strong", null, label)), /*#__PURE__*/_react["default"].createElement(RowContainer, null, inputs === null || inputs === void 0 ? void 0 : (_inputs$2 = inputs[0]) === null || _inputs$2 === void 0 ? void 0 : _inputs$2.map(function (input, id) {
            return /*#__PURE__*/_react["default"].createElement(_renderRow["default"], (0, _extends2["default"])({
              key: "curious_panda_row_field_".concat(id)
            }, _this.props, {
              input: input
            }));
          })));
        default:
          console.warn("Field type ".concat(intf, " \"").concat(label, "\" is not available"));
          return null;
      }
    }
  }]);
}(_react.PureComponent);
FieldsArray.defaultProps = {
  nowDate: new Date(),
  disabled: false
};
FieldsArray.propTypes = {
  "interface": (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, _propTypes.element]).isRequired,
  nowDate: _propTypes.object
};
var _default = exports["default"] = FieldsArray;
var ArrayFields = exports.ArrayFields = ['array', 'flatarray', 'row', 'collapsable'];